(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_actions/swish-button/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/banner_actions/swish-button/assets/javascripts/init.js');
"use strict";


(document => {
  const logger = new svs.core.log.Logger('banner_action:swish-button');
  const btnSelector = '.btn.js-banner-actions-swish-button';
  let nodes = [];
  const getWidgetPosition = element => {
    const allWidgetsOnPage = Array.from(document.querySelectorAll('.widget'));
    const widgetElement = element.closest('.widget');
    if (!widgetElement) {
      return 0;
    }
    for (let index = 0; index < allWidgetsOnPage.length; index++) {
      if (allWidgetsOnPage[index] === widgetElement) {
        return index + 1;
      }
    }
    return 0;
  };
  const startDeposit = () => {
    const depositValues = {
      amount: 100,
      skipStepOne: false
    };
    const storageTimeInMinutes = 30;
    svs.components.Storage.browser.set('depositValues', 'quick-deposit', depositValues, storageTimeInMinutes, error => {
      if (error) {
        logger.warn("Failed to set depositValues: ".concat(error));
      }
    });
  };
  const trackSwishAction = node => {
    const trackingString = node.dataset.trackingString;
    const position = getWidgetPosition(node);
    svs.components.analytics.trackPromoClick({
      name: trackingString,
      position
    });
  };
  const handleClick = event => {
    const node = event.target.closest(btnSelector);
    if (node) {
      trackSwishAction(node);
      startDeposit();
    }
  };
  const removeEventListeners = nodes => {
    nodes.forEach(node => {
      node.removeEventListener('click', handleClick);
    });
  };
  const setupEventListeners = nodes => {
    nodes.forEach(node => {
      node.addEventListener('click', handleClick);
    });
  };
  const init = () => {
    if (nodes.length) {
      removeEventListeners(nodes);
    }
    nodes = document.querySelectorAll(btnSelector);
    setupEventListeners(nodes);
  };
  init();
})(document);

 })(window);